import { compose } from "redux";

import { OfferList } from "../src/ridesNew/OfferList";
import withAuthentication from "../src/withAuthentication";
// @ts-ignore
import { OFFER_LIST, permissions } from "../src/routes";

export default compose(withAuthentication(permissions[OFFER_LIST]))(OfferList);
